import { Button, Form, Input } from "antd"
import UploadImg from "../../../components/Upload/UploadImg"
import { useEffect, useState } from "react"
import { useFoods } from "./FoodsStore"

const Edit = ({ data }) => {
  const [img, setImg] = useState(null)
  const [form] = Form.useForm()


  const { updateFood } = useFoods()

  useEffect(() => {
    form.setFieldsValue(data)
    setImg(data.img)
    console.log(data);
  }, [data])


  return (
    <Form form={form} onFinish={(values) => {
      values.img = img
      console.log(values);

      updateFood(data.id, values)
    }} layout="vertical">
      <Form.Item name="name" label="Nomi">
        <Input />
      </Form.Item>
      <Form.Item name="price" label="Narxi">
        <Input type="number" />
      </Form.Item>
      <Form.Item name="note" label="Tavsifi">
        <Input />
      </Form.Item>
      <Form.Item name="img" label="Rasm">
        <UploadImg setImgurl={setImg} imageUrl={img} />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">Saqlash</Button>
      </Form.Item>
    </Form>
  )
}

export default Edit 